import cn from 'classnames';
import styles from './BlockingLoader.module.scss';

export const getSpinnerClassNames = (spinnerClassName?: string) => {
  return cn(styles.spinner, spinnerClassName);
};
